import { useState, type InputHTMLAttributes } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

type TextInputProps = InputHTMLAttributes<HTMLInputElement>;

export function TextInput({
  className = "",
  type = "text",
  ...props
}: TextInputProps) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        className={`w-full rounded-control border border-border bg-panel-muted px-3 py-1.5 text-[13px] text-ink outline-none transition-colors placeholder:text-ink-subtle focus:border-cta focus:bg-surface ${className}`}
        type={type !== "password" ? type : visible ? "text" : "password"}
        {...props}
      />
      <button
        type="button"
        disabled={props.disabled}
        className={`absolute right-4 top-1/2 -translate-y-1/2 rounded text-ink-subtle transition-opacity hover:text-ink focus:outline-none ${type === "password" ? "" : "hidden"}`}
        onClick={() => setVisible((prev) => !prev)}
      >
        {visible ? (
          <FaEyeSlash aria-hidden="true" />
        ) : (
          <FaEye aria-hidden="true" />
        )}
      </button>
    </div>
  );
}
